import { TimeFormatOptions, Timeslot } from '@griply/types';
import { format } from 'date-fns';

import { formatDurationLabel } from './format-duration-label';
import { isNumber } from './is-number';

export type FormatTimeslotLabelOptions = {
  timeFormat: TimeFormatOptions | string;
  isNL: boolean;
};

export const formatTimeslotLabel = (
  timeslot: Timeslot | null | undefined,
  { timeFormat, isNL }: FormatTimeslotLabelOptions,
): string => {
  if (!timeslot) {
    return '';
  }

  const startDate = new Date();
  startDate.setHours(0, 0, 0, timeslot.startTime ?? 0);
  const endDate = new Date();
  endDate.setHours(
    0,
    0,
    0,
    (timeslot.startTime ?? 0) + (timeslot.duration ?? 0),
  );

  const formattedStart = isNumber(timeslot.startTime)
    ? format(startDate, timeFormat)
    : undefined;
  const formattedEnd =
    timeslot.duration && isNumber(timeslot.startTime)
      ? format(endDate, timeFormat)
      : undefined;

  if (formattedStart && formattedEnd) {
    const startMeridiem = formattedStart.slice(-2);
    const endMeridiem = formattedEnd.slice(-2);

    if (startMeridiem === endMeridiem && ['AM', 'PM'].includes(startMeridiem)) {
      return `${formattedStart.replace(` ${startMeridiem}`, '')}-${formattedEnd}`;
    }

    return `${formattedStart} - ${formattedEnd}`;
  }

  return [
    formattedStart,
    timeslot.duration && !isNumber(timeslot.startTime)
      ? formatDurationLabel(timeslot.duration, isNL)
      : undefined,
  ]
    .filter(Boolean)
    .join(' - ');
};
